import styled from 'styled-components';
import ProfileLanguages from './ProfileLanguages';
import { GetPartnerBusinessProfileResponse } from '@/api/type/types';
import { useDispatch } from 'react-redux';
import React, { useCallback, useRef, useState } from 'react';
import { businessProfile } from '@/stores/slices/business-profile/businessProfileSlice';
import BusinessTimeSettings from './BusinessTimeSettings';
import BusinessRepresentativeImage from './BusinessRepresentativeImage';
import { useTranslation } from 'react-i18next';
import { MultiLineText } from '@/components/text/MultiLineText';
import { useAppSelector } from '@/stores/hooks';
import ProfileTitle from '../../component/ProfileTitle';

interface CenterDetailInfoProps {
  profile: GetPartnerBusinessProfileResponse;
  isEdit: boolean;
}
const CenterDetailInfo = ({ profile, isEdit }: CenterDetailInfoProps) => {
  const { putBusinessProfile } = useAppSelector(
    (state) => state.businessProfile
  );
  const introductionValue =
    isEdit && putBusinessProfile?.introduction !== undefined
      ? putBusinessProfile.introduction
      : profile.introduction;

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const onChangeIntroduction = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      dispatch(
        businessProfile.putBusinessProfile({
          introduction: e.target.value,
        })
      );
    },
    [dispatch]
  );

  return (
    <Container data-en={i18n.language === 'en'}>
      <Row>
        <ProfileTitle title={t('serviceLanguage')} alignCenter="center" star />
        <ProfileLanguages data={profile.languages} isEdit={isEdit} />
      </Row>
      <InroductionRow>
        <ProfileTitle title={t('introduction')} />
        <Textarea
          data-edit={isEdit}
          disabled={!isEdit}
          onChange={onChangeIntroduction}
          value={introductionValue}
        />
      </InroductionRow>
      <Row>
        <ProfileTitle title={t('businessHours')} star />
        <BusinessTimeSettings profile={profile} isEdit={isEdit} />
      </Row>
      <BusinessRepresentativeImage profile={profile} isEdit={isEdit} />
    </Container>
  );
};

export default CenterDetailInfo;

const Row = styled.div`
  display: flex;
  gap: 18px;
`;

const InroductionRow = styled(Row)`
  margin: 31px 0 34px;
`;

const Label = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 20px;
  line-height: 140%;
  width: 147px;
  flex-shrink: 0;
  color: #6e98f8;
`;

const CenterLabel = styled(Label)`
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px 43px 0;
  text-align: start;
  &[data-en='true'] {
    ${Row} {
      gap: 0;
    }
    ${Label} {
      width: 165px;
    }
  }
`;

const Textarea = styled.textarea`
  padding: 13px 24px;
  box-sizing: border-box;
  border: 1px solid #88a2f5;
  outline: none;
  height: 153px;
  font-size: 15px;
  line-height: 140%;
  color: #000000;
  background: #ffffff;
  border-radius: 10px;
  resize: none;
  flex: 1;
  overflow-y: auto;
  &[data-edit='true'] {
    border: 1px solid #b974ff;
  }
`;
